import { ISearchModel } from "@Types/specification";
import React, { memo, useEffect, useRef, useState } from "react";

interface IProps {
  searchValue: string
  sourceData: ISearchModel[]
  handleClick: (entryId: number) => void
  onClear: () => void
}

const SearchModel: React.FC<IProps> = ({ sourceData, searchValue, handleClick, onClear }) => {
  const drawerRef = useRef<HTMLDivElement>(null);
  const [data, setData] = useState<ISearchModel[]>([])


  const handleClickOutside = (event) => {
    if (drawerRef.current && !(drawerRef.current as HTMLElement).contains(event.target as HTMLElement) && event.target.id !== 'SearchDom') {
      onClear?.();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!!searchValue) {
      const newData = sourceData.map((i) => ({
        name: i.name.replace(
          searchValue,
          `<span class="text-[#3264FF]">${searchValue}</span>`
        ),
        entryId: i.entryId,
      }));
      setData([...newData]);
    }
  }, [sourceData, searchValue])

  if (!searchValue) return null

  return (
    <section ref={drawerRef} className={`w-270 rounded-4 absolute top-36 -left-1 p-4 py-6 bg-[#fff] z-10 max-h-[232px] overflow-y-auto`} style={{ boxShadow: '0px 2px 18px 0px rgba(0,0,0,0.20)' }}>
      {Array.isArray(data) && data.length > 0 && data.map((item) => (
        <div
          key={item.entryId}
          className="text-14 text-[#1D2029] h-32 rounded-4 pl-12 flex items-center cursor-pointer hover:bg-[#E0EFFF]"
          dangerouslySetInnerHTML={{ __html: item.name }}
          onClick={() => {
            onClear?.();
            handleClick(item.entryId)
          }}
        />
      ))}

      {data.length === 0 && <div className="text-14 text-[#9DA2AF] h-32 pl-14 flex items-center">沒有找到匹配內容</div>}
    </section>
  );
};
export default memo(SearchModel);
